import { ProductType, SchemaTypes } from '@allesauto/graphql';
import findLast from 'lodash/findLast';
import { useCallback, useMemo } from 'react';

import { useShoppingCart } from './shoppingCart';

export const useAddToCartNotification = () => {
  const { data, loading: cartDataLoading } = useShoppingCart();

  const lastVehicleInCart = useMemo(
    () =>
      findLast(
        data?.items,
        (cartItem) =>
          cartItem.productType === ProductType.Vehicle ||
          cartItem.productType === ProductType.TradeInVehicle ||
          cartItem.productType === ProductType.AccessoryStandAlone
      ),
    [data]
  );

  const cartNotificationVehicle = useCallback(() => {
    const commonVehicleProps = {
      monthlyPrice: lastVehicleInCart?.payment.monthlyPrice || 0,
      price: lastVehicleInCart?.payment.price || 0,
      paymentType: lastVehicleInCart?.payment.paymentType || undefined,
    };

    if (lastVehicleInCart?.productType === ProductType.Vehicle) {
      const lastVehicle = lastVehicleInCart?.product as SchemaTypes.Vehicle;
      return {
        ...commonVehicleProps,
        vehicleId: lastVehicle?.id ?? '',
        makeName: lastVehicle?.makeName,
        modelName: lastVehicle?.modelName,
        image: (lastVehicle?.images || [])[0]?.externalUrlLarge || undefined,
        vehicleType: ProductType.Vehicle,
      };
    } else if (lastVehicleInCart?.productType === ProductType.TradeInVehicle) {
      const lastTradeInVehicle =
        lastVehicleInCart?.product as SchemaTypes.TradeInVehicle;
      return {
        ...commonVehicleProps,
        vehicleId: '',
        makeName: lastTradeInVehicle?.make,
        modelName: lastTradeInVehicle?.model,
        image: (lastTradeInVehicle?.images || [])[0]?.url || undefined,
        vehicleType: ProductType.TradeInVehicle,
      };
    } else if (
      lastVehicleInCart?.productType === ProductType.AccessoryStandAlone
    ) {
      const lastAccessory = lastVehicleInCart?.product as SchemaTypes.Accessory;
      return {
        ...commonVehicleProps,
        vehicleId: '',
        makeName: lastAccessory?.title,
        modelName: lastAccessory?.mainCategoryName,
        image: (lastAccessory?.images || [])[0]?.url || undefined,
        vehicleType: ProductType.AccessoryStandAlone,
      };
    }
    return undefined;
  }, [lastVehicleInCart]);

  return { cartNotificationVehicle, cartDataLoading };
};
